let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

/*
 * Subscribers are isolated from the publisher and from each other.
 *
 * Callbacks used to be invoked bare inside .map(), so a subscriber that threw
 * synchronously threw out of publish() itself and aborted the caller mid-way.
 * product-form.js is the case that matters: it publishes cartUpdate and then
 * calls cart.renderContents() a few lines later in the same .then() callback.
 * One bad subscriber meant the POST to /cart/add.js had already succeeded while
 * the drawer was never re-rendered or opened — a cart that looked broken until
 * the page was refreshed, with the real error buried in an unrelated .catch().
 *
 * A subscriber's failure is now its own. Rejections are collected rather than
 * short-circuited so one slow-failing subscriber cannot hide the others, and
 * every failure is logged with the event name to make the culprit obvious.
 * The return value is unchanged in shape: a promise that resolves once all
 * subscribers have settled.
 */
function publish(eventName, data) {
  if (!subscribers[eventName]) return Promise.resolve();

  const results = subscribers[eventName].map((callback) => {
    try {
      return Promise.resolve(callback(data)).catch((error) => {
        console.error(`[pubsub] "${eventName}" subscriber rejected`, error);
      });
    } catch (error) {
      console.error(`[pubsub] "${eventName}" subscriber threw`, error);
      return Promise.resolve();
    }
  });

  return Promise.all(results);
}
